import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)

import { getFrequencyFromSeconds } from '@/hooks/api/use-create-schedule-mutation'
import { FREQUENCY_VALUES } from './constants'

export const extractTimeFromDateTime = (dateTime: string | Date | undefined): string => {
  if (!dateTime) return ''

  try {
    const date = typeof dateTime === 'string' ? new Date(dateTime) : dateTime
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    return `${hours}:${minutes}`
  } catch (error) {
    console.error('Error extracting time from datetime:', error)
    return ''
  }
}

export function getHumanizedInfoFromFrequency(
  frequency: number = 0,
  startDate: string = '',
): string {
  const d = dayjs(startDate)
  if (!d.isValid()) {
    return 'Invalid start date'
  }

  if (frequency === 0) {
    return `Does not repeat. Starts on ${d.format('MMM D, YYYY h:mm A')}`
  }

  const frequencyLabel = getFrequencyFromSeconds(frequency)

  switch (frequencyLabel) {
    case FREQUENCY_VALUES.WEEKLY:
      return `Weekly on ${d.format('dddd')} at ${d.format('h:mm A')}`
    case FREQUENCY_VALUES.DAILY:
      return `Daily at ${d.format('h:mm A')}`
    case FREQUENCY_VALUES.HOURLY:
      return `Every hour at minute ${d.format('mm')}`
    case FREQUENCY_VALUES.MONTHLY:
      return `Monthly on day ${d.format('D')} at ${d.format('h:mm A')}`
    default:
      if (frequency % 86400 === 0) {
        const days = frequency / 86400
        return `Every ${days} day${days > 1 ? 's' : ''} at ${d.format('h:mm A')}`
      }
      return `Every ${dayjs.duration(frequency, 'seconds').humanize()} starting ${d.format('MMM D, YYYY h:mm A')}`
  }
}
